import React from "react";

import { ToolbarSection, ToolbarItem, ToolbarRadio } from "..";

export const StyleSettings = () => {
  return (
    <>
      <ToolbarSection
        defaultOpen={true}
        title="Layout"
        props={["width", "height"]}
        summary={({ width, height }: any) => {
          return `${width || 0} x ${height || 0}`;
        }}
      >
        <ToolbarItem propKey="width" type="text" label="Width" />
        <ToolbarItem propKey="height" type="text" label="Height" />
      </ToolbarSection>

      <ToolbarSection title="Background">
        <ToolbarItem
          propKey="backgroundColor"
          type="color"
          label="Fill color"
        />

        <ToolbarItem propKey="backgroundImage" type="text" label="Fill image" />
      </ToolbarSection>

      <ToolbarSection
        title="Margin"
        props={["margin"]}
        summary={({ margin }: any) => {
          return margin
            ? `${margin[0] || 0}px ${margin[1] || 0}px ${margin[2] || 0}px ${
                margin[3] || 0
              }px`
            : "0";
        }}
      >
        <ToolbarItem propKey="margin" index={0} type="slider" label="Top" />
        <ToolbarItem propKey="margin" index={1} type="slider" label="Right" />
        <ToolbarItem propKey="margin" index={2} type="slider" label="Bottom" />
        <ToolbarItem propKey="margin" index={3} type="slider" label="Left" />
      </ToolbarSection>
      <ToolbarSection
        title="Padding"
        props={["padding"]}
        summary={({ padding }: any) => {
          return padding
            ? `${padding[0] || 0}px ${padding[1] || 0}px ${padding[2] || 0}px ${
                padding[3] || 0
              }px`
            : "0";
        }}
      >
        <ToolbarItem propKey="padding" index={0} type="slider" label="Top" />
        <ToolbarItem propKey="padding" index={1} type="slider" label="Right" />
        <ToolbarItem propKey="padding" index={2} type="slider" label="Bottom" />
        <ToolbarItem propKey="padding" index={3} type="slider" label="Left" />
      </ToolbarSection>
      <ToolbarSection title="Decoration" props={["radius", "shadow"]}>
        <ToolbarItem
          full={true}
          propKey="radius"
          type="slider"
          label="Radius"
        />
        <ToolbarItem
          full={true}
          propKey="shadow"
          type="slider"
          label="Shadow"
        />
      </ToolbarSection>
      <ToolbarSection title="Flexbox">
        <ToolbarItem
          propKey="flexGrow"
          type="select"
          label="Grow"
          options={[
            { label: "Default", value: "" },
            { label: "Yes", value: "1" },
            { label: "No", value: "0" },
          ]}
        />
        <ToolbarItem
          propKey="flexShrink"
          type="select"
          label="Shrink"
          options={[
            { label: "Default", value: "" },
            { label: "Yes", value: "1" },
            { label: "No", value: "0" },
          ]}
        />
      </ToolbarSection>
      <ToolbarSection title="Alignment">
        <ToolbarItem
          propKey="flexDirection"
          type="radio"
          label="Flex Direction"
        >
          <ToolbarRadio value="row" label="Row" />
          <ToolbarRadio value="column" label="Column" />
        </ToolbarItem>
        <ToolbarItem propKey="fillSpace" type="radio" label="Fill space">
          <ToolbarRadio value="yes" label="Yes" />
          <ToolbarRadio value="no" label="No" />
        </ToolbarItem>
        <ToolbarItem propKey="alignItems" type="radio" label="Align Items">
          <ToolbarRadio value="flex-start" label="Flex start" />
          <ToolbarRadio value="center" label="Center" />
          <ToolbarRadio value="flex-end" label="Flex end" />
        </ToolbarItem>
        <ToolbarItem
          propKey="justifyContent"
          type="radio"
          label="Justify Content"
        >
          <ToolbarRadio value="flex-start" label="Flex start" />
          <ToolbarRadio value="center" label="Center" />
          <ToolbarRadio value="flex-end" label="Flex end" />
        </ToolbarItem>
      </ToolbarSection>
    </>
  );
};
